/* global Choices */
const customSelect = () => {
	const select_elements = document.querySelectorAll( 'select' );

	if (select_elements.length === 0) return;

	select_elements.forEach( select => {
		if ( select.closest( '.fl-lightbox' ) ) return;

		new Choices( select, {
			allowHTML: true,
			placeholder: true,
			searchEnabled: false,
			itemSelectText: ''
		} );
	})
};

export default customSelect;
